export default {
  page: {
    register: "註冊",
    login: "登錄",
    increase: "完善信息",
    phoneRegister: "手機註冊",
    bindRegister: "綁定註冊",
    bindLogin: "綁定信息",
    supplement: "補充資料",
    loginSuccess: "登錄成功",
    retrievePassword: "找回密碼",
    setPassword: "設置密碼",
    loginTip: "登錄提示",
  },
  common: {
    register: "註冊",
    hasAccount: "已有賬號，立即登錄",
    save: "保存",
    cancel: "取消",
    confirm: "確認",
    submit: "提交",
    back: "返回",
    nextStep: "下一步",
    loading: "加載中...",
    loginNow: "立即登錄",
    registerNow: "立即註冊",
    forgetPassword: "忘記密碼",
    rememberPassword: "記住密碼",
    getCaptcha: "獲取驗證碼",
    captcha: "驗證碼",
    defaultLogin: "默認登錄方式",
    otherLogin: "其他登錄方式",
    captchaLogin: "驗證碼登錄",
    passwordLogin: "密碼登錄",
    secondsLeft: "秒",
    noAccount: "沒有賬號？",
    savePassword: "保存密碼",
    password: "密碼",
    pleaseInputPassword: "請輸入密碼",
    phoneAreaCodeTip: "手機號請填寫區號，如86",
    bind: "綁定",
    noRegisterBind: "沒有註冊？完善信息後綁定",
    hasAccountBind: "已有賬號，登錄後綁定",
    bindRegisterTip:
      "由於您是第一次使用微信/QQ賬號登錄，請完善您的賬號信息，並創建密碼用於後續登錄。",
    bindLoginTitle: "請登錄您的註冊賬號，完成身份綁定",
    bindRegisterTitle: "請完善您的賬號信息，完成身份綁定",
  },
  field: {
    required: "請填寫{name}",
    pattern: "請輸入正確的{name}",
    unique: "{name}已註冊",
    repeat: "{name}已存在",
    number: "請輸入數字",
    phone: "手機號",
    correctPhone: "請輸入正確的手機號",
    email: "郵箱",
    phoneOrEmail: "手機/郵箱",
    maxLength: "輸入長度不超過{length}",
    please_select: "請選擇",
    please_input: "請輸入{name}",
    please_answer: "請回答",
    please_input_captcha: "請輸入驗證碼",
    please_upload: "請上傳",
  },
  login: {
    already_registered: "您輸入的{name}已註冊，請登錄",
    passwordLengthError: "請輸入6-20個字符",
    userUnderReview: "當前用戶正在審核中，暫時無法綁定。",
    userDisabled: "當前用戶已停用，暫時無法綁定。",
    pleaseAuthorizeFirst: "請先授權再進行綁定！",
    please_login: "請先登錄",
    login_success: "登錄成功",
    register_success: "註冊成功",
    logout_success: "退出成功",
  },
  error: {
    100054: "輸入的郵箱已存在報名信息，請輸入其他郵箱",
  },
  success: {
    credential: "參會憑證",
    attendeeId: "參會人ID",
    normalAttendee: "普通參會人員",
    category_normal: "普通參會人員",
    meetingTime: "會議時間",
  },
  lang: {
    zh_CN: "中文",
    en_US: "English",
    zh_TW: "繁體中文",
  },
};
